import { toFixedAmount } from "../components/toFixedAmount";

export const useFormattedAmount = (amount, t) => {
  return `${toFixedAmount(amount)} ${t("orderTracking.gel")}`;
};
